import axios from 'axios'

function initialState() {
  return {
    messages: [],
    totalMessageCount: 0,
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getMessages({ commit, state }, options) {      
      var limit= options.rowsPerPage == null ? 30 : options.rowsPerPage
      var offSet = options.page == null ? 0 : (options.page - 1) * limit
      
      return axios.get(`api/Messages?Offset=${offSet}&Limit=${limit}`).then((res) => {
        commit('SET_MESSAGES', res.data.Data)
        commit('SET_MESSAGES_COUNT', res.data.TotalLength)
      }).catch((error) => {
        console.log(error)
      })
    },
  },

  mutations: {
    SET_MESSAGES: (s, payload) => s.messages = payload,
    SET_MESSAGES_COUNT: (s, payload) => s.totalMessageCount = payload,
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },

  getters: {
    messages: s => s.messages,
    totalMessageCount: s => s.totalMessageCount,
  },
}